import React from 'react'
import CheckBox from '@Components/Selectors/Checkbox'

interface BulkActionCheckboxProps {
    id: string
    checked: boolean
    onToggle: () => void
    disabled?: boolean
    disabledMessage?: string
}

const BulkActionCheckbox = ({ id, checked, onToggle, disabled, disabledMessage }: BulkActionCheckboxProps) => (
    <CheckBox
        id={id}
        onClick={() => onToggle()}
        checked={checked}
        mainColor
        disabled={disabled}
        checkboxMessage={disabledMessage}
    />
)

export default BulkActionCheckbox
